const RECAPTCHA_ACTION = 'franchise_inquiry';

/**
 * Load reCAPTCHA v3 script and return a function to get a token.
 * @param {string} siteKey - reCAPTCHA v3 site key (from RAZZLE_RECAPTCHA_SITE_KEY)
 * @returns {Promise<(action?: string) => Promise<string>>} Resolves with getToken function, or null if no key
 */
export function loadRecaptcha(siteKey) {
  if (!siteKey || typeof window === 'undefined') {
    return Promise.resolve(null);
  }

  if (window.grecaptcha && window.grecaptcha.execute) {
    return Promise.resolve(action => window.grecaptcha.execute(siteKey, { action: action || RECAPTCHA_ACTION }));
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(() => {
        resolve(action => window.grecaptcha.execute(siteKey, { action: action || RECAPTCHA_ACTION }));
      });
    };
    script.onerror = () => reject(new Error('reCAPTCHA script failed to load'));
    document.head.appendChild(script);
  });
}
